// extracted by mini-css-extract-plugin
export default {"galleryContainer":"galleryCatalog_galleryContainer__x+3ks","thumbnailButton":"galleryCatalog_thumbnailButton__t7Noj"};